import { blue } from "@material-ui/core/colors";

const customTabsStyle = {
  customSwitch: {
    "&.MuiSwitch-root .MuiSwitch-switchBase": {
      color: blue[900]
    },
    "&.MuiSwitch-root .MuiSwitch-switchBase + .MuiSwitch-track": {
      backgroundColor: blue[400]
    },
    "&.MuiSwitch-root .Mui-checked + .MuiSwitch-track": {
      backgroundColor: blue[400]
    },
    "&.MuiSwitch-root .Mui-checked": {
      color: blue[900]
    },
  },
};

export default customTabsStyle;
